import React from 'react';
import { Star } from 'lucide-react';
export function TopProofBar() {
  return <div className="bg-brand-creamAlt border-b border-brand-line py-2 px-3 text-center" data-id="element-277">
      <div className="max-w-4xl mx-auto flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 text-[10px] md:text-xs font-bold leading-tight" data-id="element-278">
        <div className="flex items-center text-brand-orange" data-id="element-279">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 md:w-3.5 md:h-3.5 fill-current" data-id="element-280" />)}
        </div>
        <span className="uppercase tracking-wide text-brand-ink" data-id="element-281">
          <span className="orange-text font-black" data-id="element-282">+1.200 docentes</span> y
          capacitadores ya dejaron de improvisar
        </span>
      </div>
    </div>;
}